import { Link, useMatch } from "react-router-dom";
import { GlobalContext } from "../context/Provider";
import henceforthApi from "../utils/henceforthApi";
import React, { useState, useContext, useEffect } from "react";
import Swal from "sweetalert2";
import moment from "moment";

export default () => {
  // const [data, setData] = useState([])
  const match = useMatch("/policies/:id/:type");
  const { authState, authDispatch,handleError } = useContext(GlobalContext);
  const [state, setState] = useState([]);
  henceforthApi.setToken(authState.access_token);
  // console.log(authState)
  const initialiseData = async (_id) => {
    try {
      let apiRes = await henceforthApi.Policies.Details(match.params.id);
      setState(apiRes);
      // let obj =
      //   Array.isArray(apiRes.data) && apiRes.data.length
      //     ? apiRes.map((item) => (setData(item)))
      //     : apiRes.data;
      // setData(apiRes)
      // setState({
      //   ...state,
      //   ...obj,
      // });
    } catch (error) {
      handleError(error)
     }
  };

  // const handleDelete = () => {
  //   Swal.fire({
  //     title: "Are you sure?",
  //     text: "You won't be able to revert this!",
  //     icon: "warning",
  //     showCancelButton: true,
  //     confirmButtonColor: "#3085d6",
  //     cancelButtonColor: "#d33",
  //     confirmButtonText: "Yes, delete it!",
  //   }).then(async (result) => {
  //     if (result.isConfirmed) {
  //       try {
  //         let apiRes = await henceforthApi.Policies.delete(match.params.id);
  //         Swal.fire({
  //           title: "Policy Deleted",
  //           text: "",
  //           icon: "success",
  //           confirmButtonText: "OK",
  //         });
  //         window.history.back();
  //       } catch (error) {
  //         Swal.fire({
  //           title: "Error!",
  //           text: "",
  //           icon: "error",
  //           confirmButtonText: "Cancel",
  //         });
  //       }
  //     }
  //   });
  // };

  useEffect(() => {
    initialiseData();
  }, []);

  return (
    <div className="animated fadeInRight">
      <div className="ibox">
        <div className="ibox-title">
          <div className="d-flex justify-content-between align-items-center">
            <h3 className="flex-grow-1 text-center text-uppercase">
              {state.title}
            </h3>
            <div className="">
              <Link to="/policies" className="btn btn-primary me-3 px-4">
                <i className="fas fa-arrow-left me-1"></i>Back
              </Link>
              <Link
                className="btn btn-primary-button  me-3 px-4"
                to={`/policies/${match?.params?.id}/${match?.params?.type}/edit`}
              >
                <i className="fas fa-edit me-1"></i>Edit
              </Link>
              {/* <button onClick={() => handleDelete(data._id)} className="btn btn-danger ">
                <i className="fas fa-trash me-2"></i>delete
              </button> */}
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-md-12">
            <div className="ibox animated fadeInRight">
              <div className="ibox-title">
                <div className="title-head d-flex justify-content-between align-items-center flex-row">
                  <div>
                    <div className="UsernameDetailsSpacing">
                      <label
                        style={{
                          fontSize: "16px",
                          color: "#000000",
                          fontWeight: "bold",
                        }}
                      >
                        {  state.type == "TERM_AND_CONDITION" ? "TERMS_AND_CONDITIONS".split("_").join(" ") : state.type?.split("_").join(" ")}
                      </label>
                    </div>
                    <hr />
                    <div className="UsernameDetailsSpacing">
                      <br></br>
                      <div style={{ fontSize: "14px", color: "#303030", width: "100%" }}
                        dangerouslySetInnerHTML={{
                          __html:
                            state.description
                              ? state.description
                              : state.description
                        }}
                      >
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* <div className="ibox-content">
          <div className="py-4">

            <img
              src={
                state.image_url
                  ? `${henceforthApi.API_FILE_ROOT_ORIGINAL}${state.image_url}`
                  : About
              }
              alt=""
              className="detail-page-image"
            />
          </div>
          <p className="text-end ">
            <b>
              Last Updated:
              {moment(Number(state.created_at)).format("MMM DD, YYYY")}
            </b>
          </p>
          <div
            className="word-break-policies-detail"
            dangerouslySetInnerHTML={{ __html: state?.description }}
          ></div>

          <div className="text-end"></div>
        </div> */}
      </div>
    </div>
  );
};
